import PayPalPage from './paypal_page'
import { connect } from 'react-redux'
import { fromVeniceSelector } from 'redux/selectors/venice'

const mapStateToProps = (state, { showHeader, showFooter }) => {
  const fromVenice = fromVeniceSelector()(state)
  if (fromVenice) {
    showHeader = false
    showFooter = false
  }
  return { showHeader, showFooter }
}
export default connect(mapStateToProps)(PayPalPage)
